export const galleryData = {
  reception: [
    {
      src: '/images/gallery/reception.jpg',
      alt: '밝고 깨끗한 접수실',
      description: '민트색 포인트의 모던한 접수 데스크'
    },
    {
      src: '/images/gallery/waiting-area-1.jpg',
      alt: '연두색 계단식 대기 공간',
      description: '아이들을 위한 특별한 계단식 대기 공간'
    },
    {
      src: '/images/gallery/waiting-area-2.jpg',
      alt: '화이트 톤의 대기실',
      description: '밝고 깨끗한 화이트 톤의 대기실'
    },
    {
      src: '/images/gallery/kids-zone.jpg',
      alt: '키즈존',
      description: '아이들을 위한 치아 테마 포토존'
    }
  ],
  treatment: [
    {
      src: '/images/gallery/treatment-blue.jpg',
      alt: '블루 진료실',
      description: '차분한 분위기의 블루 테마 진료실'
    },
    {
      src: '/images/gallery/treatment-yellow.jpg',
      alt: '옐로우 진료실',
      description: '밝고 따뜻한 옐로우 테마 진료실'
    },
    {
      src: '/images/gallery/treatment-pink.jpg',
      alt: '핑크 진료실',
      description: '사랑스러운 핑크 테마 진료실'
    },
    {
      src: '/images/gallery/treatment-purple.jpg',
      alt: '퍼플 진료실',
      description: '부드러운 퍼플 테마 진료실'
    }
  ],
  consultation: [
    {
      src: '/images/gallery/consultation.jpg',
      alt: '상담실',
      description: '편안한 분위기의 상담실'
    },
    {
      src: '/images/gallery/hallway.jpg',
      alt: '복도',
      description: '따뜻한 분위기의 복도'
    }
  ]
}; 